<template>
    <div class="main">
        <div class="p-banner" :style="'background-image: url('+banner+');'"> </div>
        <div class="container">
            <div class="about-box">
                <h2 class="inBox-til">
                    关于我们
                </h2>
                <div class="details">
                    <p>{{$website_name}}是一家致力于不锈钢丝网及深加工产品，集研发、生产、销售于一体的工贸一体化企业。生产基地位于中国丝网之乡河北省安平县南部工业园12号。</p><br>
                    <p>主要产品：不锈钢筛网、不锈钢过滤网、轧花网、席型网、反差网，我厂还可以根据行业要求定做各种规格过滤网片、过滤网筒、塑料颗粒过滤网、橡胶过滤网等深加工产品。</p><br>
                    <p>公司生产设备全部采用国际先进的数控剑杆及剑带织机，严格按照市场和消费者的要求进行高效生产，保证产品质量，满足消费者的期望，真正做到高品质，工厂价。</p><br>
                    <p>产品广泛应用于石油、汽车、化工、食品、医药等行业的过滤，产品远销欧美、东南亚等国家和地区。</p><br>
                    <p>我们将提供完善的产品，有竞争力的价格和优良的服务，让客户成功和满意是我们最大的使命。</p><br>
                    <p>我们真诚地希望能与国内外友人在互惠互利的基础上建立良好的合作关系。我们会尽最大努力来满足客户的需求。</p><br>
					<br>
                    <br><br>
                </div>
            </div>
        </div>
        <div class="page-infactroy" :class="{'w-bg':index%2==1}" v-for="(item,index) in factory_data" :key="index">
            
			<h2 class="inBox-til text-center">
				{{item.title}}
				<span v-if="item.sub">{{item.sub}}</span>
			</h2>
			<div class="container">
                <div class="row">
                    
					<div class="col-sm-3" v-for="(item2,index) in item.pics" :key="index">
						<a href="javascript:;" class="pic-box mb12"><img :src="image_url_prefix+item2.url"/></a>
					</div>
                    
                </div>
            </div>
        </div>

  </div>
</template>

<script>
    import factory_data from "../assets/data/factory_data";
    import banner from "../assets/img/banner5.jpg";
    export default {
        name: 'ProductDetail',
        data :function() {
            return {
                factory_data:factory_data,
                banner: banner
            }
        },
        mounted:function(){
            $(".infactroy-box a").zoomify();
        },
        created:function () {
            //console.info($(".infactroy-box img").length);
        },
        updated:function(){
        },
        methods:{

      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue